// D-173: admin moderation: closing a table, taking a player off one, player reports and the admin phone's Today.
import { z } from "zod";
import { requestId } from "./room.js";
const reasonText = z.string().trim().min(2, "Give a reason of at least two characters.").max(140, "Keep the reason under 140 characters.");
/** POST /admin/tables/:code/close */
export const AdminTableClose = z.object({ reason: reasonText, requestId });
/** POST /admin/tables/:code/remove */
export const AdminTableRemove = z.object({ publicId: z.string().trim().min(3).max(40), reason: reasonText, requestId });
export const REPORT_REASONS = ["abuse", "cheating", "name", "other"];
export const REPORT_NOTE_MAX = 280;
/** Reports one player may send in an hour. */
export const REPORTS_PER_HOUR = 5;
/** POST /reports */
export const ReportPost = z.object({
    publicId: z.string().trim().min(3).max(40),
    reason: z.enum(REPORT_REASONS),
    note: z.string().trim().max(REPORT_NOTE_MAX, `Keep the note under ${REPORT_NOTE_MAX} characters.`).optional(),
    roomCode: z.string().regex(/^[A-Fa-f0-9]{8}$/, "Table codes are eight letters and numbers.").optional(),
    requestId,
});
/** POST /admin/reports/:id/resolve. `days` is required for suspend (1, 7 or 30). */
export const ReportResolve = z.object({
    action: z.enum(["dismiss", "mute", "suspend"]),
    days: z.union([z.literal(1), z.literal(7), z.literal(30)]).optional(),
    note: z.string().trim().max(REPORT_NOTE_MAX).optional(),
    requestId,
});
/** How long an admin's mute from a report pauses table chat and voice. */
export const CHAT_MUTE_MS = 24 * 3_600_000;
//# sourceMappingURL=moderation.js.map